import cx from "clsx";
import type React from "react";
import type { DealConstructionContext } from "~/models/DealConstruction";
import { toThousandSeparator } from "~/utils/CurrencySeparator";
import Styles from "./ConstructionList.module.scss";

type Props = {
	constructionContext: DealConstructionContext;
};

export const ConstructionAmountRow: React.FC<Props> = ({
	constructionContext
}: Props) => {
	const { constructionTotalAmount, constructionTotalAmountWithTax } =
		constructionContext;
	return (
		<tr className={cx(Styles.ListRow, Styles.Footer)}>
			<td className={Styles.OrderHandle} />
			<td className={Styles.Estimation}>
				<div className={Styles.Point}>工事代金</div>
			</td>
			<td className={Styles.UnitAmount} />
			<td className={Styles.ChargePer} />
			<td className={Styles.Amount}>
				¥{toThousandSeparator(constructionTotalAmountWithTax)}
				<div className={Styles.WithoutTax}>
					税抜：¥{toThousandSeparator(constructionTotalAmount)}
				</div>
			</td>
			<td className={Styles.Buttons} />
		</tr>
	);
};
